
<template>
  <!-- reference: http://apex.infogridpacific.com/dcp/svg-graphs-grids-coordinates.html -->
  <!-- reference: http://apex.infogridpacific.com/dcp/svg-primitives-parabolas.html -->
  <svg :width="rectWidth" :height="rectHeight" >
    <defs>
      <pattern id="grid20" width="20" height="20" patternUnits="userSpaceOnUse">
        <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#AAA" stroke-width="1"></path>
      </pattern>
    </defs>
    <!-- background and grid -->
    <rect fill="white" stroke="#999" stroke-width="1" :width="rectWidth" :height="rectHeight"  y="0"></rect>
    <rect fill="url(#grid20)" :width="rectWidth" :height="rectHeight" y="0"></rect>
    <!-- x-axis and y-axis -->
    <line stroke="black" x1="0" :y1="originY" :x2="rectWidth" :y2="originY"></line>
    <line stroke="black" :x1="originX" y1="0" :x2="originX" :y2="rectHeight"></line>
    <!-- origin -->
    <text class="axis" :x="originX - 9" :y="originY + 12">0</text>
    <!-- x-axis coordinate values -->
    <g v-for="index in this.maxx - 1" :key="'positivex' + index">
      <text v-if="index % axisNumbersBy === 0" class="axis" :x="originX + index * 20 - 3" :y="originY + 12">{{ index }}</text>
    </g>
    <g v-for="index in Math.abs(this.minx) - 1" :key="'negativex' + index">
      <text v-if="index % axisNumbersBy === 0" class="axis" :x="originX - index * 20 - 6" :y="originY + 12">{{ -index }}</text>
    </g>
    <!-- y-axis coordinate values -->
    <g v-for="index in this.maxy - 1" :key="'positivey' + index">
      <text v-if="index % axisNumbersBy === 0" class="axis" :x="originX - 9" :y="originY - index * 20 + 4">{{ index }}</text>
    </g>
    <g v-for="index in Math.abs(this.miny) - 1" :key="'negativey' + index">
      <text v-if="index % axisNumbersBy === 0" class="axis" :x="originX - 14" :y="originY + index * 20 + 4">{{ -index }}</text>
    </g>
    <!-- function graphs -->
    <g v-for="(f, index) in functions" :key="'graph' + index">
      <text v-if="f.type === 'label'" class="label" :style="'stroke:'+ f.color" :x="originX + f.x * 20" :y="originY - f.y * 20">{{ f.text }}</text>
      <circle v-if="f.type === 'point'" class="point" r="4" :style="'fill:'+ f.color" :cx="originX + f.x * 20" :cy="originY - f.y * 20"></circle>
      <line v-if="f.type === 'vertical'" class="curve" :style="'stroke:'+ f.color" :x1="originX + f.x * 20" y1="0" :x2="originX + f.x * 20" :y2="rectHeight"></line>
      <line v-if="f.type === 'horizontal'" class="curve" :style="'stroke:'+ f.color" x1="0" :y1="originY - f.y * 20" :x2="rectWidth" :y2="originY - f.y * 20"></line>
      <line v-if="f.type === 'linear'" class="curve" :style="'stroke:'+ f.color" x1="0" :y1="originY - lineY1(f)" :x2="rectWidth" :y2="originY - lineY2(f)"></line>
      <path v-if="f.type === 'quadratic'" class="curve" :style="'stroke:'+ f.color" :d="parabolaD(f)" :transform="'translate(' + originX + ',' + originY + ') scale(1,-1)'"></path>
    </g>
</svg>
</template>

<script>
export default {
  name: 'FunctionGraph',
  props: ['config', 'functions'],
  data: function () {
    return { minx: -6, maxx: 6, miny: -6, maxy: 6, axisnumbersby: 2 }
  },
  created () {
    if (this.config) Object.assign(this.$data, this.config)
  },
  computed: {
    rectWidth: function () { // coordinate plane width in pixels
      return 20 * (this.maxx - this.minx)
    },
    rectHeight: function () { // coordinate plane height in pixels
      return 20 * (this.maxy - this.miny)
    },
    originX: function () { // y-axis horizontal offset
      return this.minx * -20
    },
    originY: function () { // x-axis vertical offset
      return this.maxy * 20
    },
    axisNumbersBy: function () {
      return this.axisnumbersby
    }
  },
  methods: {
    lineY1: function (f) {
      return Math.round(f.m * this.minx * 20 + f.b * 20)
    },
    lineY2: function (f) {
      return Math.round(f.m * this.maxx * 20 + f.b * 20)
    },
    parabolaD: function (f) {
      var vertexX = -1 * f.b / (2 * f.a)
      var vertexY = f.a * vertexX * vertexX + f.b * vertexX + f.c

      var leftX = vertexX - 10
      var leftY = f.a * leftX * leftX + f.b * leftX + f.c

      var rightX = vertexX + 10
      var rightY = f.a * rightX * rightX + f.b * rightX + f.c

      var controlX = vertexX
      var controlY = f.a > 0 ? vertexY - (rightY - vertexY) : vertexY + (vertexY - rightY)

      leftX *= 20; leftY *= 20; rightX *= 20; rightY *= 20; controlX *= 20; controlY *= 20
      return 'M' + leftX + ',' + leftY + ' Q' + controlX + ',' + controlY + ' ' + rightX + ',' + rightY
    }
  }
}
</script>

<style scoped>
.axis {
  fill: black;
  font-size: 0.7rem;
}
.label {
  fill: black;
  font-size: 1rem;
}
.point {
  fill: black;
  stroke: none;
}
.curve {
  fill: none;
  stroke:blue;
  stroke-width: 3;
}
</style>



// WEBPACK FOOTER //
// src/math/elements/FunctionGraph.vue